import axios from 'axios'
var token = document.getElementsByName('csrf-token')[0].content;

export default axios.create({
  baseURL: '/dashboard',
  headers: {'X-CSRF-Token': token},

})

export const apiRoot = axios.create({
  baseURL: '/',
  headers: {'X-CSRF-Token': token},
})
